import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { TiGroup, TiThListOutline } from "react-icons/ti";
import { MdOutlinePendingActions } from "react-icons/md";
import { FaClipboardList, FaDownload } from "react-icons/fa"
import { IoCheckmarkDone } from "react-icons/io5";
import config from "../../config";

function Container() {
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({});

  const navigate = useNavigate();
 
  const movetodashboard = (e) =>{
    e.preventDefault();
    navigate("/dashboard");
  }
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const centcode = localStorage.getItem("CentCode");
      setLoading(true);
      try {
        const response = await axios.post(`${config.API_BASE_URL}/auth/CenterDashboard`,
          { cenT_CODE: centcode },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setDashboardData(response.data.data.dashboard_data[0]);
        // console.log(response.data.data.dashboard_data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const moveToList = (e) => {
    e.preventDefault();
    navigate("/student-list");
  }
  const moveToChallan = (e) => {
    e.preventDefault();
    navigate("/generate-challan");
  }
  const moveToChallanStatus = (e) => {
    e.preventDefault();
    navigate("/challan-status");
  }
  const moveToBoardPending = (e) => {
    e.preventDefault();
    navigate("/board-submission-pending");
  }
  const moveToBoardApproved = (e) => {
    e.preventDefault();
    navigate("/board-submission-approved");
  }
  const moveToRegistration = (e) => {
    e.preventDefault();
    navigate("/student-registration");
  }
  return (
    <div class="pc-container">
       {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="pc-content">
        <div class="page-header">
          <div class="page-block">
            <div class="row align-items-center">
              <div class="col-md-12 breadcrumb">
                <div class="page-header-title">
                  <h4 class="m-b-10">DASHBOARD</h4>
                </div>
                <ul class="breadcrumb">
                <li class="breadcrumb-item"><a href="" onClick={movetodashboard}>Home</a></li>
                <li class="breadcrumb-item"><a href="">Dashboard</a></li>
              </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style={{ padding: '0px' }}>
          <div class="col-md-6 col-xl-3">
            <a class="card card-blue" href="" style={{height:'144px'}} onClick={moveToRegistration}>
              <div class="card-body">
                <h5 class="mb-2 f-w-400 text-muted">Total Eligible Candidates</h5>
                <h4 class="mb-3 mt-3">{dashboardData.ELIGIBLE_CANDIDATE || ""}
                  {/* <span class="badge bg-light-primary border border-primary"><i
                    class="ti ti-trending-up"></i> 59.3%</span> */}
                </h4>
                <p class="mb-0 text-muted text-sm"><span class="text-primary">Click Here to See Details >></span>
              </p>
              </div>
              <TiGroup className="text-blue-300 text-6xl card-icon" />
            </a>
          </div>
          <div class="col-md-6 col-xl-3">
            <a class="card card-red" href='' onClick={moveToList}>
              <div class="card-body">
                <h5 class="mb-2 f-w-400 text-muted">Total Registrations Done</h5>
                <h4 class="mb-3 mt-3">{dashboardData.TOTAL_REGISTRATION_DONE || ""}
                  {/* <span class="badge bg-light-primary border border-primary"><i
                    class="ti ti-trending-up"></i> 59.3%</span> */}
                </h4>
                <p class="mb-0 text-muted text-sm"><span class="text-danger">Click Here to See Details >></span>
              </p>
              </div>
              <TiGroup className="text-red-300 text-6xl card-icon" />
            </a>
          </div>
          <div class="col-md-6 col-xl-3">
            <a class="card card-purple" href='' onClick={moveToChallan}>
              <div class="card-body">
                <h5 class="mb-2 f-w-400 text-muted">Challan Generation Pending </h5>
                <h4 class="mb-3 mt-3">{dashboardData.CHALLAN_GENERATION_PENDING || ""}
                  {/* <span class="badge bg-light-primary border border-primary"><i
                    class="ti ti-trending-up"></i> 59.3%</span> */}
                </h4>
                <p class="mb-0 text-muted text-sm"><span class="text-purple">Click Here to See Details >></span></p>
              </div>
              <TiThListOutline className="text-purple-300 text-6xl card-icon" />
            </a>
          </div>
          <div class="col-md-6 col-xl-3">
            <a class="card card-yellow" href='' onClick={moveToChallanStatus}>
              <div class="card-body">
                <h5 class="mb-2 f-w-400 text-muted">Challan Generated</h5>
                <h4 class="mb-3 mt-3">{dashboardData.CHALLAN_GENERATED || ""}
                  {/* <span class="badge bg-light-primary border border-primary"><i
                    class="ti ti-trending-up"></i> 59.3%</span> */}
                </h4>
                <p class="mb-0 text-muted text-sm"><span class="text-warning">Click Here to See Details >></span>
              </p>
              </div>
              <FaClipboardList className="text-yellow-300 text-6xl card-icon" />
            </a>
          </div>
          <div class="col-md-6 col-xl-3">
            <a class="card card-green" href='' onClick={moveToBoardPending}>
              <div class="card-body">
                <h5 class="mb-2 f-w-400 text-muted">Board Submission Pending</h5>
                <h4 class="mb-3 mt-3">{dashboardData.BOARD_SUBMISSION_PENDING || ""}
                  {/* <span class="badge bg-light-primary border border-primary"><i
                    class="ti ti-trending-up"></i> 59.3%</span> */}
                </h4>
                <p class="mb-0 text-muted text-sm"><span class="text-success">Click Here to See Details >></span>
              </p>
              </div>
              <MdOutlinePendingActions className="text-green-300 text-6xl card-icon" />
            </a>
          </div>
          <div class="col-md-6 col-xl-3">
            <a class="card card-orange" href='' onClick={moveToBoardApproved}>
              <div class="card-body">
                <h5 class="mb-2 f-w-400 text-muted">Approved by Board</h5>
                <h4 class="mb-3 mt-3">{dashboardData.APPROVED_BY_BOARD || ""}
                </h4>
                <p class="mb-0 text-muted text-sm"><span class="text-orange-300">Click Here to See Details >></span>
              </p>
              </div>
              <IoCheckmarkDone className="text-orange-300 text-6xl card-icon" />
            </a>
          </div>
         
        </div>
      </div>
    </div>
  )
}

export default Container